export const tags = [
  {
    id: 1,
    name: "women's black dress for party",
    color: "#ABCC8C",
  },
  {
    id: 2,
    name: "white casual sneakers under 10,000",
    color: "#F0DD93",
  },
  {
    id: 3,
    name: "comfortable t-shirts for daily wear",
    color: "#ABCC8C",
  },
  {
    id: 4,
    name: "shawl for winter evenings",
    color: "#9DDEEC",
  },
  {
    id: 5,
    name: "floral chiffon maxi dress for vacation",
    color: "#F0DD93",
  },
  {
    id: 6,
    name: "embroidered luxury abayas for Eid",
    color: "#FFC4B1",
  },
  {
    id: 7,
    name: "formal menswear for reception",
    color: "#ABCC8C",
  },
];

export const menProducts = [
  {
    image: require("../assets/images/men1.png"),
    title:
      "RESORT COLLAR BAGGY SHIRT BAGGY SHIRT BAGGY SHIRT BAGGY SHIRT BAGGY SHIRT BAGGY SHIRT BAGGY SHIRT",
    description:
      "Actual colour of the product may vary slightly due to photographic lighting sources or your device",
    price: "PKR 3,899",
    oldPrice: "PKR 4,899",
    tag: "Best T-shirt for Mens",
    brandLogo: require("../assets/icons/brand_logo_1.png"),
  },
  {
    image: require("../assets/images/men2.png"),
    title: "RESORT COLLAR BAGGY SHIRT",
    description:
      "Actual colour of the product may vary slightly due to photographic lighting sources or your device",
    price: "PKR 3,899",
    oldPrice: "PKR 4,899",
    tag: "Best T-shirt for Mens",
    brandLogo: require("../assets/icons/brand_logo_1.png"),
  },
  {
    image: require("../assets/images/men1.png"),
    title: "Product 3",
    description: "This is the description for product 3.",
    price: "PKR 3,899",
    oldPrice: "PKR 4,899",
    tag: "Best T-shirt for Mens",
    brandLogo: require("../assets/icons/brand_logo_1.png"),
  },
];

export const watchProducts = [
  {
    image: require("../assets/images/watch1.png"),
    title: "Sveston Hector SV-8265-M",
    description:
      "Actual colour of the product may vary slightly due to photographic lighting sources or your device",
    price: "PKR 3,899",
    oldPrice: "PKR 4,899",
    tag: "Best Watch for Mens",
    brandLogo: require("../assets/icons/brand_logo_2.png"),
  },
  {
    image: require("../assets/images/watch2.png"),
    title: "SVESTON VANESIO SV-9304-M",
    description:
      "Actual colour of the product may vary slightly due to photographic lighting sources or your device",
    price: "PKR 3,899",
    oldPrice: "PKR 4,899",
    tag: "Best Watch for Mens",
    brandLogo: require("../assets/icons/brand_logo_2.png"),
  },
  {
    image: require("../assets/images/watch1.png"),
    title: "Product 3",
    description: "This is the description for product 3.",
    price: "PKR 3,899",
    oldPrice: "PKR 4,899",
    tag: "Best Watch for Mens",
    brandLogo: require("../assets/icons/brand_logo_2.png"),
  },
];

export const perfumeData = [
  {
    image: require("../assets/images/perfume1.png"),
    title: "Scent of a Dream",
    description:
      "Actual colour of the product may vary slightly due to photographic lighting sources or your device",
    price: "PKR 3,899",
    oldPrice: "PKR 4,899",
    tag: "Best Perfume for Mens",
    brandLogo: require("../assets/icons/brand_logo_3.png"),
  },
  {
    image: require("../assets/images/perfume2.png"),
    title: "earth Pefume for men",
    description:
      "Actual colour of the product may vary slightly due to photographic lighting sources or your device",
    price: "PKR 3,899",
    oldPrice: "PKR 4,899",
    tag: "Best Perfume for Mens",
    brandLogo: require("../assets/icons/brand_logo_3.png"),
  },
  {
    image: require("../assets/images/perfume1.png"),
    title: "Product 3",
    description: "This is the description for product 3.",
    price: "PKR 3,899",
    oldPrice: "PKR 4,899",
    tag: "Best Perfume for Mens",
    brandLogo: require("../assets/icons/brand_logo_3.png"),
  },
];

export const productImages = [
  require("../assets/images/product-detail1.png"),
  require("../assets/images/product-detail2.png"),
  require("../assets/images/product-detail3.png"),
  require("../assets/images/product-detail4.png"),
];

export const bannerImages = [
  require("../assets/images/banner1.png"),
  require("../assets/images/banner2.png"),
  require("../assets/images/banner1.png"),
  require("../assets/images/banner2.png"),
];

export const similarProducts = [
  {
    id: 1,
    title: "Product 1",
    price: "PKR 16295",
    image: require("../assets/images/similar.png"),
  },
  {
    id: 2,
    title: "Product 2",
    price: "PKR 16295",
    image: require("../assets/images/similar.png"),
  },
  {
    id: 3,
    title: "Product 3",
    price: "PKR 16295",
    image: require("../assets/images/similar.png"),
  },
  {
    id: 4,
    title: "Product 4",
    price: "PKR 16295",
    image: require("../assets/images/similar.png"),
  },
];

export const storeMenProducts = [
  {
    id: 1,
    title: "Black Kurta",
    price: "PKR 16295",
    image: require("../assets/images/men.png"),
  },
  {
    id: 2,
    title: "Black Kurta",
    price: "PKR 16295",
    image: require("../assets/images/men.png"),
  },
  {
    id: 3,
    title: "Black Kurta",
    price: "PKR 16295",
    image: require("../assets/images/men.png"),
  },
  {
    id: 4,
    title: "Black Kurta",
    price: "PKR 16295",
    image: require("../assets/images/men.png"),
  },
];

export const storeWomenProducts = [
  {
    id: 1,
    title: "Printed Shirt",
    price: "PKR 16295",
    image: require("../assets/images/women.png"),
  },
  {
    id: 2,
    title: "Printed Shirt",
    price: "PKR 16295",
    image: require("../assets/images/women.png"),
  },
  {
    id: 3,
    title: "Printed Shirt",
    price: "PKR 16295",
    image: require("../assets/images/women.png"),
  },
  {
    id: 4,
    title: "Printed Shirt",
    price: "PKR 16295",
    image: require("../assets/images/women.png"),
  },
];

export const searchTypes = [
  {
    id: 1,
    title: "On Sale",
    image: require("../assets/images/men.png"),
  },
  {
    id: 2,
    title: "New Arrival",
    image: require("../assets/images/product-detail1.png"),
  },
  {
    id: 3,
    title: "Men",
    image: require("../assets/images/product-detail2.png"),
  },
  {
    id: 4,
    title: "Women",
    image: require("../assets/images/women.png"),
  },
  {
    id: 5,
    title: "Men Kurta",
    image: require("../assets/images/product-detail2.png"),
  },
  {
    id: 6,
    title: "Women Kurta",
    image: require("../assets/images/women.png"),
  },
];

export const searchResults = [
  {
    id: 1,
    title: "Wash & Wear Suit",
    image: require("../assets/images/product-detail1.png"),
    price: "PKR 10,585",
    brandLogo: require("../assets/icons/ss.png"),
  },
  {
    id: 2,
    title: "BAGGY FIT CHECK SHIRT",
    image: require("../assets/images/product-detail2.png"),
    price: "PKR 15,585",
    brandLogo: require("../assets/icons/sapphire.png"),
  },
];

export const brandLogos = [
  require("../assets/images/brand_logos/1st-step-logo.png"),
  require("../assets/images/brand_logos/Edenrobe_Logo.png"),
  require("../assets/images/brand_logos/FHS_logo.png"),
  require("../assets/images/brand_logos/LAMA-removebg-preview.png"),
  require("../assets/images/brand_logos/Malak_logo.png"),
  require("../assets/images/brand_logos/Sapphire-logo.png"),
  require("../assets/images/brand_logos/aghanoor.png"),
  require("../assets/images/brand_logos/aliasghar_perfumes.png"),
  require("../assets/images/brand_logos/amir-adnan.png"),
  require("../assets/images/brand_logos/bareeze_logo.png"),
  require("../assets/images/brand_logos/beechtree_logo.png"),
  require("../assets/images/brand_logos/bonanza_satrangi_logo.png"),
  require("../assets/images/brand_logos/cambridge_logo.png"),
  require("../assets/images/brand_logos/dhanak.png"),
  require("../assets/images/brand_logos/diners_logo.png"),
  require("../assets/images/brand_logos/ego_logo.png"),
  require("../assets/images/brand_logos/ethnc_logo.jpg"),
  require("../assets/images/brand_logos/generations-logo.png"),
  require("../assets/images/brand_logos/hang_ten_logo.png"),
  require("../assets/images/brand_logos/hopscotch_logo.png"),
  require("../assets/images/brand_logos/hunza_candles_logo.png"),
  require("../assets/images/brand_logos/hush-puppies_logo.png"),
  require("../assets/images/brand_logos/ideas_gulahmed_logo.png"),
  require("../assets/images/brand_logos/image_logo.png"),
  require("../assets/images/brand_logos/insigma_logo.png"),
  require("../assets/images/brand_logos/jafferjees-logo.png"),
  require("../assets/images/brand_logos/junaidjamshed_logo.png"),
  require("../assets/images/brand_logos/kayseria_logo.png"),
  require("../assets/images/brand_logos/khaddi_logo.png"),
  require("../assets/images/brand_logos/lawrancepur_logo.png"),
  require("../assets/images/brand_logos/lesirueclub_logo.png"),
  require("../assets/images/brand_logos/lifestyle-collection_logo.png"),
  require("../assets/images/brand_logos/mango_logo.png"),
  require("../assets/images/brand_logos/meme_logo.png"),
  require("../assets/images/brand_logos/minnie-minors_logo.png"),
  require("../assets/images/brand_logos/moosajee_logo.png"),
  require("../assets/images/brand_logos/nakoosh-logo.png"),
  require("../assets/images/brand_logos/outfitters_logos.png"),
  require("../assets/images/brand_logos/ows-logo.png"),
  require("../assets/images/brand_logos/panache_logo.png"),
  require("../assets/images/brand_logos/polkadots-logo.webp"),
  require("../assets/images/brand_logos/revolution_logo.jpg"),
  require("../assets/images/brand_logos/saeed-ghani-logo.png"),
  require("../assets/images/brand_logos/salitax_logo.png"),
  require("../assets/images/brand_logos/sanasafinaz_logo.png"),
  require("../assets/images/brand_logos/sara_ali_cosmatics_logo.png"),
  require("../assets/images/brand_logos/sarwana_jewelers.png"),
  require("../assets/images/brand_logos/saya_logo.png"),
  require("../assets/images/brand_logos/shaffer_logo.png"),
  require("../assets/images/brand_logos/sheep_logo.png"),
  require("../assets/images/brand_logos/silk-skin_logo.png"),
  require("../assets/images/brand_logos/sputnick_logo.png"),
  require("../assets/images/brand_logos/sulafah_logo.webp"),
  require("../assets/images/brand_logos/unbeatables_logo.png"),
  require("../assets/images/brand_logos/unzelondon_logo.png"),
  require("../assets/images/brand_logos/vitality_logo.png"),
  require("../assets/images/brand_logos/vohra-sohgal_logo.png"),
  require("../assets/images/brand_logos/zeenwomen_logo.png"),
];

export const brandLogoMap = [
  { name: "Khaadi", logo: require("../assets/images/brand_logos/khaddi_logo.png"), scale: 1.5 },
  { name: "ETHNC", logo: require("../assets/images/brand_logos/ethnc_logo.jpg"), scale: 0.7 },
  { name: "Maria.B. Designs", logo: require("../assets/images/brand_logos/mariab_logo.png"), scale: 0.9 },
  { name: "Sana Safinaz", logo: require("../assets/images/brand_logos/sanasafinaz_logo.png"), scale: 2.7 },
  { name: "Sapphire", logo: require("../assets/images/brand_logos/Sapphire-logo.png"), scale: 2.5 },
  { name: "LimeLight", logo: require("../assets/images/brand_logos/limelight_logo.png"), scale: 2.5 },
  { name: "Zellbury", logo: require("../assets/images/brand_logos/zellbury_logo.png"), scale: 1.2 },
  { name: "Lulusar", logo: require("../assets/images/brand_logos/lulusar_logo.png") },
  { name: "Sobia Nazir", logo: require("../assets/images/brand_logos/sobianazir_logo.png"), scale: 1.1 },
  { name: "Almirah", logo: require("../assets/images/brand_logos/almirah_logo.png") },
  { name: "BEECHTREE", logo: require("../assets/images/brand_logos/beechtree_logo.png"), scale: 0.9 },
  { name: "J. Junaid Jamshed", logo: require("../assets/images/brand_logos/junaidjamshed_logo.png") },
  { name: "Baroque", logo: require("../assets/images/brand_logos/baroque_logo.jpg") },
  { name: "Generation", logo: require("../assets/images/brand_logos/generations-logo.png"), scale: 1.4 },
  { name: "Image", logo: require("../assets/images/brand_logos/image_logo.png"), scale: 2.0 },
  { name: "Ismail Farid Pakistan", logo: require("../assets/images/brand_logos/ismailfarid_logo.png"), scale: 1.1 },
  { name: "GulAhmed Ideas", logo: require("../assets/images/brand_logos/ideas_gulahmed_logo.png"), scale: 2.5 },
  { name: "Lama", logo: require("../assets/images/brand_logos/LAMA-removebg-preview.png"), scale: 2.5 },
  { name: "Kayseria", logo: require("../assets/images/brand_logos/kayseria_logo.png") },
  { name: "Minnie Minors", logo: require("../assets/images/brand_logos/minnie-minors_logo.png") },
  { name: "Niamia", logo: require("../assets/images/brand_logos/niamia_logo.png"), scale: 1.2 },
  { name: "So Wears", logo: require("../assets/images/brand_logos/sowears_logo.png"), scale: 1.3 },
  { name: "Vanya", logo: require("../assets/images/brand_logos/vanya_logo.png") },
  { name: "Zeen Women", logo: require("../assets/images/brand_logos/zeenwomen_logo.png"), scale: 2.5 },
  { name: "Zainab Chottani", logo: require("../assets/images/brand_logos/zainabchottani_logo.png"), scale: 1.1 },
  { name: "Farah Talib Aziz", logo: require("../assets/images/brand_logos/farahtalibaziz_logo.png"), scale: 1.2 },
  { name: "Jazmin", logo: require("../assets/images/brand_logos/jazmin_logo.webp"), scale: 1.5 },
  { name: "Iznik", logo: require("../assets/images/brand_logos/iznik_logo.webp"), scale: 0.9 },
  { name: "Azure", logo: require("../assets/images/brand_logos/azure_logo.jpg"), scale: 0.8 },
  { name: "Elan", logo: require("../assets/images/brand_logos/elan_logo.png"), scale: 0.8 },
];
